export default __webpack_public_path__ + "static/media/autodiagnostic-OEPV-vierge.6a9f4d3b.pdf";